export default "/images/c4bc425255b92989b06a4ec4cb9aeaf6.avif";